export enum ImportFieldType {
  ACCOUNT_ID = 'accountId',
  EXTERNAL_ID = 'string',
  SERVICE_TYPE = 'serviceType',
  PROGRAM_TYPE = 'programType',
  DATE = 'date',
  TAGS = 'string',

  ORIGIN_ADDRESS1 = 'string',
  ORIGIN_ADDRESS2 = 'string',
  ORIGIN_APARTMENT = 'string',
  ORIGIN_CITY = 'string',
  ORIGIN_STATE = 'string',
  ORIGIN_COUNTRY = 'string',
  ORIGIN_STREET = 'string',
  ORIGIN_HOUSE = 'string',
  ORIGIN_ZIP_CODE = 'string',
  ORIGIN_ENTRANCE = 'string',
  ORIGIN_FLOOR = 'string',
  ORIGIN_ELEVATOR = 'string',
  ORIGIN_LAT = 'float',
  ORIGIN_LNG = 'float',
  ORIGIN_FROM_TIME = 'string',
  ORIGIN_TO_TIME = 'string',
  ORIGIN_SERVICE_TIME_MINUTES = 'integer',
  ORIGIN_CONTACT_PHONE = 'string',
  ORIGIN_CONTACT_ADDITIONAL_PHONE = 'string',
  ORIGIN_CONTACT_NAME = 'string',
  ORIGIN_DEPOT_ID = 'depotId',

  DESTINATION_ADDRESS1 = 'string',
  DESTINATION_ADDRESS2 = 'string',
  DESTINATION_APARTMENT = 'string',
  DESTINATION_CITY = 'string',
  DESTINATION_STATE = 'string',
  DESTINATION_COUNTRY = 'string',
  DESTINATION_STREET = 'string',
  DESTINATION_HOUSE = 'string',
  DESTINATION_ZIP_CODE = 'string',
  DESTINATION_ENTRANCE = 'string',
  DESTINATION_FLOOR = 'string',
  DESTINATION_ELEVATOR = 'integer',
  DESTINATION_LAT = 'float',
  DESTINATION_LNG = 'float',
  DESTINATION_FROM_TIME = 'string',
  DESTINATION_TO_TIME = 'string',
  DESTINATION_SERVICE_TIME_MINUTES = 'integer',
  DESTINATION_CONTACT_PHONE = 'string',
  DESTINATION_CONTACT_ADDITIONAL_PHONE = 'string',
  DESTINATION_CONTACT_NAME = 'string',
  DESTINATION_DEPOT_ID = 'depotId',


  PACKAGE_BARCODE = 'string',
  PACKAGE_SHELF_ID = 'string',
  PACKAGE_COUNT = 'integer',
  PACKAGE_NUMBER_OF_ITEMS = 'integer',
  PACKAGE_REQUIRED_SPOTS = 'integer',
  PACKAGE_VOLUME = 'float',
  PACKAGE_WEIGHT = 'float',
  PACKAGE_VALUE = 'float',
  PACKAGE_DESCRIPTION = 'string',
  DIMENSIONS_HEIGHT = 'float',
  DIMENSIONS_WIDTH = 'float',
  DIMENSIONS_LENGTH = 'float',
  PACKAGE_TYPE = 'packageType'

}
